import { render, staticRenderFns } from "./TimePunch.vue?vue&type=template&id=44e1a77e&scoped=true&"
import script from "./TimePunch.vue?vue&type=script&lang=js&"
export * from "./TimePunch.vue?vue&type=script&lang=js&"
import style0 from "./TimePunch.vue?vue&type=style&index=0&id=44e1a77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1a77e",
  null
  
)

export default component.exports